import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@ngrx/store';
import { select } from '@ngrx/store';
import { Subject } from 'rxjs/internal/Subject';
import { getStepDetails } from 'visa-store';
import { LetterPreviewLibraryComponent } from 'letter-preview-library';
import { PdfViewLibraryComponent } from 'pdf-view-library';
import { LetterTemplateLibraryComponent } from 'letter-template-library';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { environment } from 'environment-configurations';
import * as i2 from 'ngx-toastr';
import * as i4 from 'app-services-library';

class APISupportLetter {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getGeneratedUploadDocuments(visatype, caseType, caseId, categoryCode) {
        return this.httpClient.get(`/${visatype}/${caseType}/${caseId}/document/category/${categoryCode} `).pipe(map((response) => {
            return response;
        }));
    }
    UploadSupportLetter(visaType, caseType, caseId, docType, payload) {
        return this.httpClient.post(`/${visaType}/${caseType}/${caseId}/letter/${docType}/upload`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    deleteSupportLetter(documentId, companyId, petitionId) {
        return this.httpClient.delete(`/document/${documentId}/company/${companyId}/petition/${petitionId}`).pipe(map((response) => {
            return response;
        }));
    }
    deleteCoverLetter(documentId, companyId, petitionId) {
        return this.httpClient.delete(`/green/card/document/${documentId}`).pipe(map((response) => {
            return response;
        }));
    }
    deleteSupportLetterGreenCard(documentId) {
        return this.httpClient.delete(`/green/card/document/${documentId}`).pipe(map((response) => {
            return response;
        }));
    }
    // GREENCARD
    UploadGreenCardSupportLetter(visaType, caseType, caseId, docType, payload) {
        return this.httpClient.post(`/task/${visaType}/case/${caseId}/letter/${docType}/upload`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getGeneratedUploadGreenCardDocuments(visatype, caseType, caseId, categoryCode) {
        return this.httpClient.get(`/superTask/${visatype}/subTask/${caseType}/gc/i140Case/${caseId}/document/category/${categoryCode} `).pipe(map((response) => {
            return response;
        }));
    }
}
APISupportLetter.ɵfac = function APISupportLetter_Factory(t) { return new (t || APISupportLetter)(i0.ɵɵinject(i1.HttpClient)); };
APISupportLetter.ɵprov = i0.ɵɵdefineInjectable({ token: APISupportLetter, factory: APISupportLetter.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(APISupportLetter, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class BaseSupportLetterLibraryService {
    constructor(store, toastr, componentFactoryResolver, apiService, appServicesLibraryService) {
        this.store = store;
        this.toastr = toastr;
        this.componentFactoryResolver = componentFactoryResolver;
        this.apiService = apiService;
        this.appServicesLibraryService = appServicesLibraryService;
        this.observableSubscription$ = new Subject();
        this.isGenerated = true;
        this.isUploaded = false;
        sessionStorage.setItem('typeOfLetter', 'SUPLTR');
    }
    loadInit() {
        if (sessionStorage.getItem('wizardTID') == null) {
            // Get Specific step details by passing step code
            this.store.pipe(select(getStepDetails, { id: this.inputData.stepId })).
                pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 ? "MARK_COMPLETE" : "MARK_SUBMIT";
                this.stepDetails = data;
                this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
                // this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" || this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
                this.handleRedirection('LetterTemplate');
            });
        }
        else {
            this.handleRedirection('LetterTemplate');
        }
        this.getGenerateUploadData();
    }
    loadComponent(component) {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
        const viewContainerRef = this.supportLetterPlaceHolder.viewContainerRef;
        viewContainerRef.clear();
        const componentRef = viewContainerRef.createComponent(componentFactory);
        componentRef.instance.primaryData = this.inputData;
        componentRef.instance.redirectionComponent
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((input) => {
            this.handleRedirection(input);
        });
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
    handleRedirection(componentName = 'LetterTemplate') {
        switch (componentName) {
            case 'LetterTemplate':
                this.loadComponent(LetterTemplateLibraryComponent);
                break;
            case 'LetterPreview':
                this.loadComponent(LetterPreviewLibraryComponent);
                break;
            case 'LetterPDF':
                this.loadComponent(PdfViewLibraryComponent);
                break;
        }
    }
    getGenerateUploadData() {
        this.apiService.getGeneratedUploadDocuments(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, 'DOCTYP')
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response.status == 200 && response.data) {
                var currentInd;
                for (let i = 0; i < response.data.length; i++) {
                    currentInd = response.data.map(function (item) {
                        return item.fileName;
                    }).indexOf('supportletter');
                }
                let _data = response.data[currentInd];
                this.isGenerated = _data.isGenerated;
                this.isUploaded = _data.isUploaded;
                this.uploadedFileName = _data.uploadedFileName;
                this.generatedOn = _data.generatedOn;
                this.fileSrc = _data.fileLocation;
                this.documentId = _data.id;
            }
        });
    }
    uploadForm(_data) {
        let files = _data[0];
        const formData = new FormData();
        formData.append('file', files);
        this.apiService.UploadSupportLetter(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, 'SUPLTR', formData).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            this.getGenerateUploadData();
            if (response) {
                this.toastr.success(response.message, 'Success');
            }
        });
    }
    handleGenerateForm(value) {
        this.isGenerated = value;
    }
    viewDocument(url) {
        const docPath = url.substring(23);
        window.open(`${environment.docs}${docPath}`, '_blank');
    }
    deleteUploadedDocument(id) {
        if (this.inputData.caseType == "I130") {
            this.apiService.deleteSupportLetterGreenCard(id).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                let _data = response.data;
                this.isGenerated = _data.isGenerated;
                this.isUploaded = _data.isUploaded;
                this.uploadedFileName = _data.uploadedFileName;
                this.generatedOn = _data.generatedOn;
                this.fileSrc = _data.fileLocation;
                this.documentId = _data.id;
                this.toastr.success(response.message, "Success");
            });
        }
        else {
            this.apiService.deleteSupportLetter(id, this.inputData.companyId, this.inputData.petitionId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
                this.toastr.success(response.message, "Success");
                let _data = response.data;
                this.isGenerated = _data.isGenerated;
                this.isUploaded = _data.isUploaded;
                this.uploadedFileName = _data.uploadedFileName;
                this.generatedOn = _data.generatedOn;
                this.fileSrc = _data.fileLocation;
                this.documentId = _data.id;
            });
        }
        this.getGenerateUploadData();
    }
}
BaseSupportLetterLibraryService.ɵfac = function BaseSupportLetterLibraryService_Factory(t) { return new (t || BaseSupportLetterLibraryService)(i0.ɵɵinject(i1$1.Store), i0.ɵɵinject(i2.ToastrService), i0.ɵɵinject(i0.ComponentFactoryResolver), i0.ɵɵinject(APISupportLetter), i0.ɵɵinject(i4.AppServicesLibraryService)); };
BaseSupportLetterLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: BaseSupportLetterLibraryService, factory: BaseSupportLetterLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseSupportLetterLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$1.Store }, { type: i2.ToastrService }, { type: i0.ComponentFactoryResolver }, { type: APISupportLetter }, { type: i4.AppServicesLibraryService }]; }, null); })();

/*
 * Public API Surface of base-support-letter-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { APISupportLetter, BaseSupportLetterLibraryService };
//# sourceMappingURL=base-support-letter-library.js.map
